import { MFNames } from './MFNames';
import type { Stands } from './Stands';

export const appHostMfs = {
	[`${MFNames.efr}`]: MFNames.efr,
	[`${MFNames.efrFast}`]: MFNames.efrFast,
	[`${MFNames.reki}`]: MFNames.reki,
};

export const appHosts: {
	[appHost in keyof typeof appHostMfs]: Record<Stands, string>;
} = {
	efr: {
		test: 'https://efrtest.ru',
		cert: 'https://efrcert.ru',
		prod: 'https://efr.ru',
	},
	efrFast: {
		test: 'https://fast.efrtest.ru',
		cert: 'https://fast.efrcert.ru',
		prod: 'https://fast.efr.ru',
	},
	reki: {
		test: 'https://reki.efintest.ru',
		cert: 'https://reki.efincert.ru',
		prod: 'https://reki.efin.ru',
	},
};
export type AppHostNames = keyof typeof appHosts;
